import type { MainModel } from "../types/main-model";

let model: MainModel | undefined;

export default {
    setModel(_model: MainModel){
        model = _model;
    },
}

export function creditsToCash(credits: number, gcr?: number){
    return Number(credits) / getGameCreditsRate(gcr);
}

export function getGameCreditsRate(gcr?: number): number{
    if(!model) return 100;
    
    if(typeof gcr === 'number') return gcr;
    if(model.playerInfo?.mainAccount?.gameCreditsRate) return model.playerInfo?.mainAccount?.gameCreditsRate;
    return 100;
}